import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { ServerService } from 'src/services/server.service';

@Component({
    selector: 'app-maintenance-mode-toggle',
    templateUrl: './maintenance-mode-toggle.component.html',
    styleUrls: ['./maintenance-mode-toggle.component.scss'],
    standalone: false
})
export class MaintenanceModeToggleComponent {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  private enums = inject(Enums);
  private serverService = inject(ServerService);

  confirmationPassword: string;
  disabledSubmit = false;

  @Input() turn_on: boolean;

  @Input() maintenanceType;

  reset() {
    this.activeModal.close();
  }

  submit() {
    if (this.confirmationPassword != undefined) {
      switch (this.maintenanceType) {
        case this.enums.MAINTENANCE_TOGGLE:
          this.toggleMaintenanceMode();
          break;
        case this.enums.STANDBY_STORAGE_TOGGLE:
          this.toggleStandbyStorage();
          break;
        case this.enums.READONLY_DB:
          this.readOnlyDB();
          break;
      }
    }
  }

  async toggleMaintenanceMode() {
    this.disabledSubmit = true;

    const result = await this.serverService.toggleMaintenanceMode(this.turn_on, this.confirmationPassword);
    if (result) {
      this.disabledSubmit = false;
      if (this.turn_on == true)
        this.sharedService.openAlert("Successfully turned ON maintenance mode", ALERT_TYPE.SUCCESS);
      else
        this.sharedService.openAlert("Successfully turned OFF maintenance mode", ALERT_TYPE.SUCCESS);
      this.activeModal.close();
    }
  }

  async toggleStandbyStorage() {
    this.disabledSubmit = true;

    const result = await this.serverService.toggleStandbyStorage(this.turn_on, this.confirmationPassword);
    if (result) {
      this.disabledSubmit = false;
      if (this.turn_on == true)
        this.sharedService.openAlert("Successfully turned ON STANDBY STORAGE", ALERT_TYPE.SUCCESS);
      else
        this.sharedService.openAlert("Successfully turned OFF STANDBY STORAGE", ALERT_TYPE.SUCCESS);
      this.activeModal.close();
    }
  }

  async readOnlyDB() {
    this.disabledSubmit = true;

    const result = await this.serverService.toggleReadOnlyDB(this.turn_on, this.confirmationPassword);
    if (result) {
      this.disabledSubmit = false;
      if (this.turn_on == true)
        this.sharedService.openAlert("Successfully turned ON READONLY DB", ALERT_TYPE.SUCCESS);
      else
        this.sharedService.openAlert("Successfully turned OFF READONLY DB", ALERT_TYPE.SUCCESS);
      this.activeModal.close();
    }
  }
}
